import { combineReducers } from 'redux'
import { merge } from 'lodash'
import paginate from '../../reducers/paginate'

const customForms = (state = { newsletterWidget: null, contactWidget: null, customContactForm: null }, action) => {
  if (action.response && action.response.customForms) {
    return merge({}, state, action.response.customForms)
  }

  return state
}

const customPagination = combineReducers({
  stockPrices: paginate({
    mapActionToKey: action => action.target,
    types: [
      'FIND_STOCK_PRICES_REQUEST',
      'FIND_STOCK_PRICES_SUCCESS',
      'FIND_STOCK_PRICES_FAILURE'
    ]
  })
})

export default { customForms, customPagination }



// WEBPACK FOOTER //
// ./src/custom/reducers/index.js